exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eventImage[data-v-1063d294]{width:270px;height:175px}.actions .toggler[data-v-1063d294]{width:100%;text-align:center;padding:10px 20px;border:2px solid #ededed;font-family:proxima-nova,Arial,Helvetica Neue,Helvetica,sans-serif;cursor:pointer;-webkit-transition:all .3s ease;transition:all .3s ease}.toggler[data-v-1063d294]:hover{color:#0e7f86;border:2px solid #0e7f86}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1063d294","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/News.vue
// module id = JiKA
// module chunks = 1